export const option = {
  fontFamily: [
    { name: '고딕', value: 'AppleSDGothic, apple sd gothic neo, noto sans korean, noto sans korean regular, noto sans cjk kr, noto sans cjk, nanum gothic, malgun gothic, dotum, arial, helvetica, sans-serif' },
    { name: '명조', value: 'nanum myoungjo, 바탕, batang, serif' }
  ],
  buttonType: [
    { name: '사각형', value: 'square-full' },
    { name: '라운드', value: 'round-full' },
  ],
  buttonTypeOption: {
    'square-full' : {
      borderRadius: '3px',
    },
    'round-full' : {
      borderRadius: '500px',
    },
    'square-line' : {
      borderRadius: '3px',
      borderWidth: '2px',
      borderStyle: 'solid',
      background: '',
      color: '#3A79E3',
      borderColor: '#3A79E3',
    }, 
    'round-line' : {
      borderRadius: '500px',
      borderWidth: '2px',
      borderStyle: 'solid',
      background: '',
      color: '#3A79E3',
      borderColor: '#3A79E3',
    }
  },
  ctaPaddingBySize: {
    // '12px': '12px 18px 10px',
    // '14px': '12px 20px 10px',
    // '16px': '14px 24px 11px',
    // '18px': '15px 26px 12px',
    // '20px': '15px 28px 12px',
    // '26px': '15px 32px 12px',
    // '32px': '18px 30px 14px',
    // '40px': '18px 30px 14px',
    // '48px': '18px 30px 14px',
    // '60px': '18px 30px 14px',
    '12px': '17px 18px',
    '14px': '17px 20px',
    '16px': '19px 20px',
    '18px': '20px 26px',
    '20px': '20px 28px',
    '26px': '20px 32px',
    '32px': '23px 30px',
    '40px': '23px 30px',
    '48px': '23px 30px',
    '60px': '23px 30px',
  },
  ctaAlign: [
    { name: '왼쪽', value: 'left' },
    { name: '가운데', value: 'center' },
    { name: '오른쪽', value: 'right' }
  ],
  textAlign: [
    { name: '왼쪽', value: 'left' },
    { name: '가운데', value: 'center' },
    { name: '오른쪽', value: 'right' },
    { name: '양끝', value: 'justify' }
  ],
  linkStyle: [
    {name: '굵게', target: 'fontWeight', value: 'normal'},
    {name: '밑줄', target: 'textDecoration', value: 'underline'},
    {name: '밑줄', target: 'textDecoration', value: 'line-through'},
  ],
  fontSize: [
    { value:12, name: '12px' },
    { value:14, name: '14px' },
    { value:16, name: '16px' },
    { value:18, name: '18px' },
    { value:20, name: '20px' },
    { value:26, name: '26px' },
    { value:32, name: '32px' },
    { value:40, name: '40px' },
    { value:48, name: '48px' },
    { value:60, name: '60px' },
  ],
  boxPadding: [
    { name: '없음', value: 0 },
    { name: '좁게', value: 5 },
    { name: '보통', value: 15 },
    { name: '넓게', value: 25 } // 20
  ],
  boxMargin: [
    { name: '없음', value: 0 },
    { name: '좁게', value: 5 },
    { name: '보통', value: 15 },
    { name: '넓게', value: 25 } 
  ],
  columnPadding: [
    { name: '없음', value: 0 },
    { name: '좁게', value: 5 },
    { name: '보통', value: 15 },
    { name: '넓게', value: 25 }
  ],
  borderWidth: [
    { name: '없음', value: 0 },
    { name: '얇게', value: 1 },
    { name: '보통', value: 2 },
    { name: '굵게', value: 3 }
  ],
  borderStyle: [
    { name: 'solid', value: 'solid' },
    { name: 'dashed', value: 'dashed' },
    { name: 'dotted', value: 'dotted' }
  ],
  borderWidthPartition: [
    { name: '얇게', value: 1 },
    { name: '보통', value: 2 },
    { name: '굵게', value: 3 }
  ],
  columnCount: [
    { name: '1단', value: 1 },
    { name: '2단', value: 2 }
  ],
  partitionStyle: [
    { name: 'solid', value: 'solid' },
    { name: 'dashed', value: 'dashed' },
    { name: 'dotted', value: 'dotted' },
  ],
  headerType: [
    { name: '없음', value: 'none' },
    { name: '오른쪽', value: 'right' },
    { name: '왼쪽', value: 'left' },
  ],
  snsStyle: [
    { name: '브랜드 컬러', value: 'snsA' },
    { name: '흰색', value: 'snsB' },
    { name: '검정색', value: 'snsD' },
    { name: '회색(로고)', value: 'snsC' },
  ],
  shareStyle: [
    { name: '브랜드 컬러', value: 'snsA' },
    { name: '흰색', value: 'snsB' },
    { name: '검정색', value: 'snsD' },
    { name: '회색', value: 'snsC' },
  ],
  snsList: [
    {
      id: 15,
      value: "homepage2",
      label: "홈페이지",
      url: "https://",
      active: true
    },
    {
      id: 1,
      value: "facebook",
      label: "페이스북",
      url: "https://",
      active: true
    },
    {
      id: 4,
      value: "instagram",
      label: "인스타그램",
      url: "https://",
      active: true
    },
    {
      id: 2,
      value: "twitter",
      label: "X",
      url: "https://",
      active: true
    },
    {
      id: 3,
      value: "blog",
      label: "블로그",
      url: "https://",
      active: true
    },
    {
      id: 5,
      value: "youtube",
      label: "유튜브",
      url: "https://",
      active: true
    },
    {
      id: 6,
      value: "brunch",
      label: "브런치",
      url: "https://",
      active: true
    },
    {
      id: 7,
      value: "naver",
      label: "네이버",
      url: "https://",
      active: true
    },
    {
      id: 8,
      value: "post",
      label: "네이버포스트",
      url: "https://",
      active: true
    },			
    {
      id: 9,
      value: "happybean",
      label: "해피빈",
      url: "https://",
      active: true
    },
    {
      id: 10,
      value: "kakaostory",
      label: "카카오스토리",
      url: "https://",
      active: true
    },
    {
      id: 11,
      value: "channel",
      label: "카카오채널",
      url: "https://",
      active: true
    },
    {
      id: 12,
      value: "band",
      label: "밴드",
      url: "https://",
      active: true
    },
    {
      id: 13,
      value: "medium",
      label: "미디엄",
      url: "https://",
      active: true
    },
    {
      id: 14,
      value: "linkedin",
      label: "링크드인",
      url: "https://",
      active: true
    },
    {
      id: 15,
      value: "tiktok",
      label: "틱톡",
      url: "https://",
      active: true
    },
    {
      id: 16,
      value: "discord",
      label: "디스코드",
      url: "https://",
      active: true
    },
    {
      id: 0,
      value: "homepage",
      label: "웹사이트",
      url: "https://",
      active: true
    },
  ]
}